import React, { useState } from "react";
import { C } from "../theme";
import { fmtD, Kpi, Btn, Inp, Sel } from "../shared";

export const DocumentsPage = ({ documents, setDocuments, immId }) => {
  const [modal,     setModal]     = useState(false);
  const [search,    setSearch]    = useState("");
  const [catFilter, setCatFilter] = useState("Tous");
  const [form, setForm] = useState({nom:"",cat:"PV",shared:false});
  const list     = documents.filter(d => d.immId === immId && d.nom.toLowerCase().includes(search.toLowerCase()));
  const filtered = catFilter === "Tous" ? list : list.filter(d => d.cat === catFilter);
  const cats     = ["Tous","PV","Règlement","Contrat","Finance","Technique","Autre"];
  const extColor = {pdf:[C.red,"#fee2e2"],xlsx:[C.green,"#d1fae5"],docx:[C.blue,C.blueL]};
  const save = () => {
    setDocuments(p => [...p, {id:Date.now(), immId, ...form, taille:"—", date:new Date().toISOString().slice(0,10), ext:"pdf"}]);
    setModal(false);
    setForm({nom:"",cat:"PV",shared:false});
  };
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
        <div>
          <h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Gestion Documentaire</h2>
          <p style={{color:C.muted,fontSize:13}}>{list.length} documents · Stockage sécurisé Cloud</p>
        </div>
        <div style={{display:"flex",gap:10}}>
          <input placeholder="🔍 Rechercher..." value={search} onChange={e => setSearch(e.target.value)}
            style={{padding:"9px 15px",borderRadius:10,border:`1.5px solid ${C.border}`,fontFamily:"DM Sans",fontSize:13,outline:"none",width:200}} />
          <Btn onClick={() => setModal(true)}>+ Ajouter</Btn>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:20}}>
        <Kpi icon="📁" label="Total"    value={list.length}                       color={C.blue}  delay={0} />
        <Kpi icon="🔓" label="Partagés" value={list.filter(d=>d.shared).length}   color={C.teal}  delay={60} />
        <Kpi icon="🔒" label="Privés"   value={list.filter(d=>!d.shared).length}  color={C.muted} delay={120} />
        <Kpi icon="📄" label="PDF"      value={list.filter(d=>d.ext==="pdf").length} color={C.red} delay={180} />
      </div>
      <div style={{display:"flex",gap:7,marginBottom:16,flexWrap:"wrap"}}>
        {cats.map(c => (
          <button key={c} className="btn" onClick={() => setCatFilter(c)}
            style={{padding:"5px 13px",borderRadius:20,fontSize:12,fontWeight:600,background:catFilter===c?C.teal:"#fff",color:catFilter===c?"#fff":C.muted}}>
            {c}
          </button>
        ))}
      </div>
      <div style={{background:C.card,borderRadius:16,boxShadow:"0 2px 14px rgba(11,19,51,.06)",overflow:"hidden"}}>
        <table>
          <thead><tr><th>Document</th><th>Catégorie</th><th>Taille</th><th>Date</th><th>Visibilité</th><th>Actions</th></tr></thead>
          <tbody>
            {filtered.map(d => {
              const [ec,eb] = extColor[d.ext] || [C.muted,"#f3f4f6"];
              return (
                <tr key={d.id}>
                  <td>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <div style={{width:32,height:32,borderRadius:7,background:eb,display:"flex",alignItems:"center",justifyContent:"center",color:ec,fontWeight:700,fontSize:10,textTransform:"uppercase"}}>{d.ext}</div>
                      <span style={{fontWeight:600,color:C.text}}>{d.nom}</span>
                    </div>
                  </td>
                  <td><span style={{background:C.blueL,color:C.blue,padding:"2px 8px",borderRadius:7,fontSize:11,fontWeight:600}}>{d.cat}</span></td>
                  <td style={{color:C.muted}}>{d.taille}</td>
                  <td style={{color:C.muted}}>{fmtD(d.date)}</td>
                  <td><span style={{background:d.shared?"#d1fae5":"#f3f4f6",color:d.shared?"#065f46":"#6b7280",padding:"2px 8px",borderRadius:7,fontSize:11,fontWeight:600}}>{d.shared?"🔓 Partagé":"🔒 Privé"}</span></td>
                  <td>
                    <div style={{display:"flex",gap:5}}>
                      <button className="btn" onClick={() => alert(`Téléchargement de "${d.nom}" initié`)}
                        style={{padding:"4px 9px",background:C.tealL,color:C.teal,borderRadius:7,fontWeight:600,fontSize:11}}>⬇️</button>
                      <button className="btn" onClick={() => setDocuments(p => p.filter(x => x.id!==d.id))}
                        style={{padding:"4px 9px",background:"#fee2e2",color:C.red,borderRadius:7,fontWeight:600,fontSize:11}}>🗑️</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {modal && (
        <div className="ov" onClick={() => setModal(false)}>
          <div className="mb" onClick={e => e.stopPropagation()}>
            <h3 style={{fontSize:19,fontWeight:800,color:C.text,marginBottom:20}}>Ajouter un document</h3>
            <Inp label="Nom du document" value={form.nom} onChange={v => setForm({...form,nom:v})} placeholder="Ex: PV AG 2024" />
            <Sel label="Catégorie" value={form.cat} onChange={v => setForm({...form,cat:v})} options={cats.filter(c=>c!=="Tous")} />
            <div style={{border:`2px dashed ${C.border}`,borderRadius:10,padding:"20px",textAlign:"center",marginBottom:14}}>
              <p style={{fontSize:22,marginBottom:5}}>📤</p>
              <p style={{fontSize:13,fontWeight:600,color:C.text}}>Cliquez pour sélectionner un fichier</p>
              <p style={{fontSize:11,color:C.muted}}>PDF, XLSX, DOCX — Max 20 MB</p>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
              <input type="checkbox" checked={form.shared} onChange={e => setForm({...form,shared:e.target.checked})} />
              <label style={{fontSize:13,fontWeight:600,color:C.text}}>Partager avec les copropriétaires</label>
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <Btn onClick={() => setModal(false)} outline>Annuler</Btn>
              <Btn onClick={save}>Enregistrer</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

